import React, { Component } from "react";
import { connect } from "react-redux";
import { changeView, start } from "../actions/assessment";
import imgBulb from "./../assets/img/icon-bulb.svg";

import { Translate } from "react-redux-i18n";
import { SaveUserStateToServerHelper } from "./Helper";

export class OpenQuestionInstructions extends Component {
  componentDidMount() {
    SaveUserStateToServerHelper(this.props.assessment);
  }

  render() {
    const i18n = require("react-redux-i18n").I18n;

    return (
      <div className="main container-fluid h-100">
        <div className="row test-container align-items-md-center">
          <div className="col-12">
            <div className="container">
              <div className="test-instruction ">
                <div className="row  justify-content-center ">
                  <div className="col-md- ">
                    <h3 className="mt-5 mb-4">
                      <Translate value="open_question_instruction" />
                    </h3>
                    <div className="reminder">
                      <img
                        src={imgBulb}
                        className="d-table-cell"
                        width="30px"
                        height="30px"
                        alt={i18n.t("instruct")}
                      />
                      <p className="lead">
                        <Translate value="instruct_lead" />
                      </p>
                    </div>
                    <div>
                      <p className="pt-2">
                        <Translate value="open_question_instruction_part_one" />
                      </p>
                      <p className="pt-2">
                        <Translate value="open_question_instruction_part_two" />
                      </p>
                      <p className="pt-2">
                        <Translate value="open_question_instruction_part_three" />
                      </p>
                    </div>

                    <p className="pt-2">
                      <Translate value="instruct_start" />
                    </p>

                    <div className="mt-4">
                      <div className="button-wrap mt-md-5">
                        <button
                          onClick={this.props.show_open_question}
                          className="btn btn-main btn-global ord-1"
                        >
                          <Translate value="start" />
                        </button>
                        <button
                          onClick={this.props.exit_session}
                          className="btn btn-outline-white btn-global ord-2"
                        >
                          <Translate value="exit_session" />
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
  instruction: state.assessment.exams[state.assessment.exam_index].instruction,
  is_ptsd: state.assessment.exams[state.assessment.exam_index].is_ptsd,
});

const mapDispatchToProps = (dispatch) => ({
  start: () => dispatch(start()),
  show_open_question: () => dispatch(changeView("open_question_form1")),
  exit_session: () => dispatch(changeView("session_details")),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpenQuestionInstructions);
